import { api } from '@/lib/api';
export type TranscriptConcept = { title: string; body: string };
export type StudyTranscript = {
  id: string;
  document_id: string;
  version: number;
  state: 'unverified' | 'confirmed';
  text: string;
  warnings: string[];
  concepts: TranscriptConcept[];
  concept_ids: string[];
  source_revision: string;
  page_number: number;
  request_id: string;
  stars_charged: number;
  model: string;
};
export type TranscriptQuote = {
  model: string;
  stars: number;
  scope: string;
  source_revision: string;
  page_number: number;
};
export type TranscriptExtract = {
  request_id: string;
  expected_version: number;
  expected_stars: number;
  source_revision: string;
  page_number: number;
};
export type TranscriptConfirm = Omit<TranscriptExtract, 'expected_stars'> & {
  text: string;
  concepts: TranscriptConcept[];
};
const path = (id: string) => `/study/documents/${encodeURIComponent(id)}/transcript`;
export const getTranscript = (id: string, page = 1) =>
  api<StudyTranscript | null>(`${path(id)}?page_number=${page}`);
export const quoteTranscript = (id: string, page = 1) =>
  api<TranscriptQuote>(`${path(id)}/quote?page_number=${page}`);
export const extractTranscript = (id: string, input: TranscriptExtract) =>
  api<StudyTranscript>(path(id), { method: 'POST', body: input });
export const confirmTranscript = (id: string, input: TranscriptConfirm) =>
  api<StudyTranscript>(`${path(id)}/confirm`, { method: 'POST', body: input });
export type TranscriptSearchPage = {
  items: Array<{
    id: string;
    document_id: string;
    file_name: string;
    page_number: number;
    text: string;
  }>;
  next_cursor: string | null;
  scope: string;
};
export const searchTranscripts = (search: string, cursor?: string) =>
  api<TranscriptSearchPage>(
    `/study/transcripts/search?${new URLSearchParams({ search, ...(cursor ? { cursor } : {}) })}`,
  );
